import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { __GetReferenceOutputForm } from "request/configuration/__ProductProcess";

/**
 * Hook para obtener referencias de productos de formulario de salida (getReferenceOutputForm)
 * Cachea los datos para evitar peticiones duplicadas
 * 
 * @param {number|string} qualifiedUser_id - ID del usuario calificado
 * @param {number|string} outputForm_id - ID del formulario de salida
 * @param {number|string} operation_code - Código de operación
 * @param {boolean} enabled - Si la query debe ejecutarse (default: true)
 * @returns {Object} Objeto con data, isLoading, error, etc. de React Query
 */
export const useReferenceOutputForm = (
  qualifiedUser_id,
  outputForm_id,
  operation_code,
  enabled = true
) => {
  const token = useSelector((state) => state.auth.dataUser.token);

  return useQuery({
    queryKey: ["referenceOutputForm", qualifiedUser_id, outputForm_id, operation_code],
    queryFn: async () => {
      if (!qualifiedUser_id || !outputForm_id || !operation_code) {
        return [];
      }

      const body = new FormData();
      body.append("qualifiedUser_id", qualifiedUser_id);
      body.append("outputForm_id", outputForm_id);
      body.append("operation_code", operation_code);

      const res = await __GetReferenceOutputForm(token, body);
      return res?.data?.status?.data || [];
    },
    enabled: enabled && !!token && !!qualifiedUser_id && !!outputForm_id && !!operation_code,
    staleTime: 1000 * 60 * 5, // 5 minutos - los productos pueden cambiar
    gcTime: 1000 * 60 * 15, // 15 minutos en caché
    refetchOnMount: false, // No refetch al montar si los datos están frescos
    refetchOnWindowFocus: false, // No refetch al cambiar de ventana
    retry: 1, // Solo reintentar una vez en caso de error
  });
};
